export const GET_CATEGORIES = 'pam/GET_CATEGORIES'
export const GET_CATEGORIES_SUCCESS = 'pam/GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_FAIL = 'pam/GET_CATEGORIES_FAIL'

export const ADD_CATEGORY = 'pam/ADD_CATEGORY'
export const ADD_CATEGORY_SUCCESS = 'pam/ADD_CATEGORY_SUCCESS'
export const ADD_CATEGORY_FAIL = 'pam/ADD_CATEGORY_FAIL'

export const UPDATE_CATEGORY = 'pam/UPDATE_CATEGORY'
export const UPDATE_CATEGORY_SUCCESS = 'pam/UPDATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_FAIL = 'pam/UPDATE_CATEGORY_FAIL'

export const DELETE_CATEGORY = 'pam/DELETE_CATEGORY'
export const DELETE_CATEGORY_SUCCESS = 'pam/DELETE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_FAIL = 'pam/DELETE_CATEGORY_FAIL'

export const pamGetCategories = payload => ({
  type: GET_CATEGORIES,
  payload
})

export const pamGetCategoriesSuccess = payload => ({
  type: GET_CATEGORIES_SUCCESS,
  payload
})

export const pamGetCategoriesFail = payload => ({
  type: GET_CATEGORIES_FAIL,
  payload
})

export const pamAddCategory = payload => ({
  type: ADD_CATEGORY,
  payload
})

export const pamAddCategorySuccess = payload => ({
  type: ADD_CATEGORY_SUCCESS,
  payload
})

export const pamAddCategoryFail = payload => ({
  type: ADD_CATEGORY_FAIL,
  payload
})

export const pamUpdateCategory = payload => ({
  type: UPDATE_CATEGORY,
  payload
})

export const pamUpdateCategorySuccess = payload => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload
})

export const pamUpdateCategoryFail = payload => ({
  type: UPDATE_CATEGORY_FAIL,
  payload
})

export const pamDeleteCategory = payload => ({
  type: DELETE_CATEGORY,
  payload
})

export const pamDeleteCategorySuccess = payload => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload
})

export const pamDeleteCategoryFail = payload => ({
  type: DELETE_CATEGORY_FAIL,
  payload
})
